import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./styles/global.css";
import "leaflet/dist/leaflet.css";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import { ActionModalProvider } from "./app/Providers/ActionModalProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ActionModalProvider>
      <App />
    </ActionModalProvider>
  </React.StrictMode>,
);
